module.exports = __webpack_public_path__ + "static/img/chabanegokiy.7ab0512.jpg";